import { createAction } from 'redux-actions'

const RESET_USER = 'RESET_USER'
const SET_USER_TOKENS = 'SET_USER_TOKENS'

const actions = {
    resetUser: createAction(RESET_USER),
    setUserTokens: createAction(SET_USER_TOKENS)
}

const types = {
    RESET_USER,
    SET_USER_TOKENS
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/users.js